import { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import { deviceDetect } from 'react-device-detect';
import Modal from '@material-ui/core/Modal';
import api from "api/Api"
import logo from 'logo.svg';
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3, 1),
    },
}));

const RiskInfoView = ({ token, redirectLink, data }) => {
    useEffect(async () => {
        await api.callBackLog(token, data, redirectLink, "risk_info", deviceDetect())
    }, []);
    console.log(data)
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleRedirect = async () => {

        window.location.href = data.risk.url
    }
    const handleBack = () => {
        window.history.back()
    }

    const body = (
        <Container className={classes.paper} >

            <Grid container spacing={3}>

                {data.risk.detail.map(function (object, i) {
                    // console.log(object, i)
                    return (
                        <Grid item xs={12} >
                            <strong>{object.key}</strong>
                            <br />

                            <span>{object.value}</span>
                        </Grid>)
                })}
                <Grid item xs={12} >
                    <strong>URL</strong>
                    <br />

                    <span style={{ overflowWrap: "break-word" }}>{data.risk.url}</span>
                </Grid>
            </Grid>

        </Container >

    );

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Container className={classes.modal}>
                        <img style={{ "maxWidth": "30vh", height: "15vh" }} src={logo} alt="logo" />
                    </Container>

                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }} >

                    <h1>{data.risk.result_dec}</h1>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }} >
                    <Button variant="outlined" color="primary" onClick={handleOpen} >View Details</Button>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Button style={{ backgroundColor: "#5DBB46", color: 'white' }} onClick={() => handleRedirect()} variant="contained" color="primary" >
                        Continue To Website
                    </Button>
                </Grid>
            </Grid >
            <Modal
                className={classes.modal}
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    )
}

export default RiskInfoView
